import { render } from "./ArrowButton.vue?vue&type=template&id=0c724f7d"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/ArrowButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c724f7d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c724f7d', __exports__)) {
    api.reload('0c724f7d', __exports__)
  }
  
  module.hot.accept("./ArrowButton.vue?vue&type=template&id=0c724f7d", () => {
    api.rerender('0c724f7d', render)
  })

}


export default __exports__